'use client';
import useSearchParams from '@/hooks/useSearchParams';
import FilterItemWithCheckbox from './filter-item-with-checkbox';
import { Button } from '@/components/ui/buttons';
import { FilterContainer } from './filter-container';
import PriceFilter from './priceFilter';
import { useState, useCallback, useEffect } from 'react';
import SkuFilter from './sku-filter';
import { event_filters_used } from '@/utils/gtm';
// import SubCategories from './sub-categories';

const DesktopFilters = ({
  filters,
  t,
  onFilter,
  searchIndexName,
  isFromSearch = false,
  // catId,
}) => {
  const { resetFilterQueryHandler, getFilterObj } = useSearchParams();

  const hasOtherFilters = Object.keys(getFilterObj ?? {})?.some(
    (key) => !['q', 'sortBy', 'sortDir', 'sort']?.includes(key)
  );

  const filterList = isFromSearch
    ? filters
        ?.filter((e) => e?.list?.length)
        .map((f, idx) => ({ ...f, key: idx }))
    : filters?.others?.map((f) => ({ ...f, key: f.code }));

  // store per-filter selected counts: { [filterKey]: number }
  const [selectedCounts, setSelectedCounts] = useState({});

  useEffect(() => {
    const counts = Object.entries(getFilterObj || {})
      ?.map(([key, value]) => ({ key, value: value?.split(',')?.length || 0 }))
      ?.reduce((obj, item) => {
        obj[item?.key] = item?.value || 0;
        return obj;
      }, {});
    !isFromSearch ? setSelectedCounts(counts) : null;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // helper to set selected count for a specific filter
  const setSelectedFor = useCallback((filterKey, count) => {
    setSelectedCounts((prev) => ({ ...prev, [filterKey]: count }));
  }, []);
  return (
    <>
      <div className='sticky top-12 mb-5 hidden overflow-y-auto bg-white md:flex md:max-h-[80vh]'>
        <div className='flex w-full flex-col gap-[9px]'>
          <PriceFilter
            removeTitle
            showInputs={false}
            searchIndexName={searchIndexName}
            isFromSearch={isFromSearch}
            mode={isFromSearch ? 'algolia' : 'category'}
          />
          <SkuFilter
            searchIndexName={searchIndexName}
            mode={isFromSearch ? 'algolia' : 'category'}
          />
          {filterList?.map((filter) => (
            <FilterContainer
              title={filter.title}
              key={filter.key}
              isFromSearch={isFromSearch}
              selected={selectedCounts[filter.key] ?? 0}
            >
              <FilterItemWithCheckbox
                data={filter}
                removeTitle
                onFilter={isFromSearch ? onFilter : undefined}
                parent={isFromSearch ? filter : undefined}
                isFromSearch={isFromSearch}
                t={t}
                setSelected={(count) => setSelectedFor(filter.key, count)}
                selected={selectedCounts[filter.key] ?? 0}
              />
            </FilterContainer>
          ))}

          {/* {!isFromSearch && <SubCategories {...{ catId, t }} />} */}
          <Button
            disabled={!hasOtherFilters}
            className='bg-primary rounded-[10px]! text-[15px] font-bold disabled:bg-[#788099]'
            onClick={() => {
              event_filters_used({
                filter_name: 'All Filters',
                filter_action: 'reset',
              });
              resetFilterQueryHandler();
              // clear the counts immediately so UI updates without waiting for children
              setSelectedCounts({});
            }}
          >
            {t('Reset Filter')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default DesktopFilters;
